<template>
  <div class="home">
    <Navbar />
    <Footer />
    <v-form ref="form" v-model="valid">
      <v-container fluid>
        <v-row>
          <v-col lg="12" md="12" cols="12" v-if="check_search">
            <span class="ml-2">
              <h2 style="display: inline;">รายการค้นหา&nbsp;</h2>
            </span>
            <v-divider class="mt-2"></v-divider>
          </v-col>
        </v-row>
        <v-row align="center" justif="center">
          <v-col lg="12">
            <v-expansion-panels multiple v-model="panel">
              <v-expansion-panel v-for="(item,i) in search_result" :key="i">
                <v-expansion-panel-header>
                  <v-container>
                    <v-row>
                      <v-col lg="4" md="4" cols="12">
                        <b style="font-size: 20px;">{{i+1}}.&nbsp;{{item[i].barcode}}</b>
                        <br />
                        <p class="mt-2" style="font-size: 20px;">{{item[item.length-1].location}}</p>
                      </v-col>
                      <v-col lg="4" md="4" cols="12">
                        <b style="font-size: 20px;">{{item[item.length-1].status_description}}</b>
                      </v-col>
                      <v-col lg="4" md="4" cols="12">
                        <b
                          style="font-size: 20px;"
                        >วันที่&nbsp;{{item[item.length-1].status_date.split(" ")[0]}}</b>
                        <p
                          class="mt-2"
                          style="font-size: 20px;"
                        >เวลา {{(item[item.length-1].status_date.split("+")[0]).split(" ")[1]}}</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-timeline dense right align-top>
                    <v-timeline-item v-for="(list,i) in item" :key="i" small>
                      <v-container>
                        <v-row>
                          <v-col>{{list.status_date.split("+")[0]}}&nbsp;น.</v-col>
                          <v-col>{{list.location}}</v-col>
                          <v-col>
                            {{list.status_description}}
                            <span
                              v-if="list.receiver_name !== null"
                            >({{list.receiver_name}})&nbsp;({{list.delivery_description}})</span>
                            <br />
                            <v-img
                              width="50%"
                              :src="list.signature"
                              v-if="list.receiver_name !== null"
                              :aspect-ratio="1"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-timeline-item>
                  </v-timeline>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-dialog v-model="dialog" width="500">
      <v-container style="background-color:white">
        <v-row>
          <v-col>
            <v-img :src="signature_img" :aspect-ratio="1"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
export default {
  components: { Navbar, Footer },
  data() {
    return {
      dialog: false,
      signature_img:
        "https://trackimage.thailandpost.co.th/f/signature/QDMzMDA5YjVzMGx1VDMz/QGI1c0VEMGx1VDMx/QGI1czBsVEh1VDM0/QGI1czBsdTAzMzdUMzI=",
      panel: [0],
      check_search: false,
      item_size: null,
      search_result: [],
      valid: true,
      rules: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => (v && v.length >= 13) || "ข้อมูลต้องมีอย่างน้อย 13 ตัว",
      ],
    };
  },
  mounted() {
    let data = {
      status: "all",
      language: "TH",
      barcode: [],
    };
    data.barcode.push(window.location.hash.split("=")[1]);
    const headers_get_token = {
      "Content-Type": "application/json",
      Authorization:
        "Token B@H0KPVsX-OWM?EgGsB%BeK5ZNXhQNEVAqIeU:K5L+N1XrLRMNAJY5PaGoJHEhMXYyP4ZLYTI|Y%LoAkQvGMDwHzC$FMQVJ/LCAL",
    };
    axios
      .post(
        "https://trackapi.thailandpost.co.th/post/api/v1/authenticate/token",
        "",
        {
          headers: headers_get_token,
        }
      )
      .then((res) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: "Token " + res.data.token,
        };
        axios
          .post("https://trackapi.thailandpost.co.th/post/api/v1/track", data, {
            headers: headers,
          })
          .then((res) => {
            this.check_search = true;
            this.search_result = Object.values(res.data.response.items);
            this.search_size = this.search_result.length;
          });
      });
  },
};
</script>
<style >
.home {
  margin: 5%;
}
@media (max-width: 600px) {
  .home {
    margin-top: 15% !important;
    margin-bottom: 25% !important;
  }
}
.v-input__slot {
  margin: 0px !important;
}
.v-text-field__details {
  display: none;
}
</style>
